import styled from "styled-components";

export const StyledHeroSection = styled("section")`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

export const HeroContainer = styled("div")`
  padding-block: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HeroTitle = styled("h1")(
  ({ theme }) => `
  font-weight: 800;
  font-size: 48px;
  line-height: 1.1;
  text-align: center;
  max-width: 800px;
  margin-bottom: 16px;
  color: ${theme.colorText};
`,
);

export const HeroTitleHighlight = styled("span")(
  ({ theme }) => `
  color: ${theme.colorPrimary};
`,
);

export const HeroSubtitle = styled("h4")(
  ({ theme }) => `
  margin-bottom: 32px;
  font-weight: 400;
  text-align: center;
  max-width: 700px;
  color: ${theme.colorTextSecondary};
  font-size: 20px;
`,
);

export const SearchContainer = styled("div")(
  ({ theme }) => `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  background-color: ${theme.colorBgContainer};
  border-radius: 60px;
  padding: 8px 8px 8px 24px;
  box-shadow:
    0 20px 60px rgba(108, 92, 231, 0.15),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  max-width: 900px;
  width: 100%;

  @media (max-width: 768px) {
    border-radius: 16px;
    padding: 16px;
  }
`,
);

export const SearchDivider = styled("div")(
  ({ theme }) => `
  width: 1px;
  height: 40px;
  background-color: ${theme.colorBorder};
  margin: auto 0;
`,
);

export const PopularSearches = styled("div")`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  margin-top: 24px;
`;
